// extracted by mini-css-extract-plugin
module.exports = {"outter":"Button_outter__2kwVJ","inner":"Button_inner__zNO9j","text":"Button_text__2RPhU"};